__turbopack_context__.v({
  "detailTextareaWrp": "scheduleDemoForm-module-scss-module__23gseq__detailTextareaWrp",
  "fullWidth": "scheduleDemoForm-module-scss-module__23gseq__fullWidth",
  "halfWidth": "scheduleDemoForm-module-scss-module__23gseq__halfWidth",
  "halfWidthDesktop": "scheduleDemoForm-module-scss-module__23gseq__halfWidthDesktop",
  "recaptchaWrp": "scheduleDemoForm-module-scss-module__23gseq__recaptchaWrp",
  "scheduleDemoForm": "scheduleDemoForm-module-scss-module__23gseq__scheduleDemoForm",
  "submitBtnContainer": "scheduleDemoForm-module-scss-module__23gseq__submitBtnContainer",
  "timeAtSelect": "scheduleDemoForm-module-scss-module__23gseq__timeAtSelect",
});
